import * as THREE from 'three';

/**
 * Scales a point relative to an original point by a given scale factor.
 * @param {THREE.Vector3} point - The point to be scaled.
 * @param {number} scaleFactor - The factor by which to scale the point.
 * @param {THREE.Vector3} original - The original point used as a reference for scaling.
 * @returns {THREE.Vector3} The scaled point relative to the original point.
 */
export const scalePoint = (point: THREE.Vector3, scaleFactor: number, original: THREE.Vector3 = new THREE.Vector3(0, 0, 0)): THREE.Vector3 => {
  const newX = original.x + scaleFactor * (point.x - original.x);
  const newY = original.y + scaleFactor * (point.y - original.y);
  const result = new THREE.Vector3(newX, newY, point.z);
  return result;
};